export default "__VITE_ASSET__Da$Fg1mm__"